









import { Component, Vue } from 'vue-property-decorator';
import { StoryUser, howJoinedTypes, likelyToBeTypes, tutorialSteps } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';

@Component({
  name: 'MagicURL',
  components: { }
})
export default class MagicURLView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public code: string

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    // get code from URL
    this.code = this.$route.params.code

    // send to server to get authentication credentials and path to redirect to
    await this.fetchData()
  }

private async fetchData(): Promise<void> {

    this.$store.commit('setLoading', { loading: true });
    try {
        let url: string = utils.getURLprefix() + '/api/auth/useMagic'
        url += `?code=${this.code}`
        const response: any = await utils.makeGetCall(url);

        // error check
        if (response.data.error) {
          this.$store.commit('setLoading', { loading: false });
          try { await this.$router.push({ name: 'home', params: { title: 'Error', msg: response.data.error }}) } catch (Error) {}
          return
        }

        // ok, we should definitely get path back
        const path: string = response.data.path
 
        // if got user and sessionId back, then log them in and send them to right path
        if (response.data.user && response.data.sessionId) {
          const user: StoryUser = new StoryUser(response.data.user)
          utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)

          // @ts-ignore: because segment analytics is loaded in head script
          window.analytics.alias(user.getIdAsString())  // tie the previously anon user to this newly id'd user

          try { await this.$router.push({ path }) } catch (Error) {}
        }

        // if we got only user back, then this means user was already logged in, so no need to update sessionId, but might as well refresh user
        if (response.data.user && !response.data.sessionId) {
          const user: StoryUser = new StoryUser(response.data.user)
          utils_auth.saveAuthStuffToStoreAndLocalStorage(user, null)
          try { await this.$router.push({ path }) } catch (Error) {}
        }

        // wacky case -- if we get neither back, then this means the existing logged in user was not the right user, but can continue with current sessionId and just go to path (hopefully he has permission)
        if (!response.data.user && !response.data.sessionId) {
          try { await this.$router.push({ path }) } catch (Error) {}
        }

        // sometimes, due to probably a race condition, when the user visits tutorial story using a magic url,
        //  the tutorial doesn't fire on their phone.  so let's make sure it fires if appropriate.
        if (response.data.user) {
          const user: StoryUser = new StoryUser(response.data.user)
          if (!user.tutorialStepsDone.includes('finishingScreen')) {
            this.$store.commit('setInTutorial', { inTutorial: true });
            await this.$router.go(0)
          }
        }

    } catch (error) {
      utils.toast(this, 'Error', 'Could not load story')
      if (this.$store.state.devmode) console.error(error);
    }
    this.$store.commit("setLoading", { loading: false });


  }

}

